import { Box, FormControlLabel, Switch } from "@mui/material";

interface DefaultAddressToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled: boolean;
}

export default function DefaultAddressToggle({
  checked,
  onChange,
  disabled,
}: Readonly<DefaultAddressToggleProps>) {
  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(_e, value) => onChange(value)}
            disabled={disabled}
          />
        }
        label="Set as default address"
      />
    </Box>
  );
}
